import Image from 'next/image';
import React from 'react';

import { Box, Flex } from '@/box';
import { useTranslation } from '@/i18n';
import { Divider } from '@/ui/layout';
import { useTheme } from '@/ui/theme';
import { BodySmall, Text } from '@/ui/typography';

export const DisloyaltySidePanel = () => {
  const { themeKey, coBrandedDisloyaltyLogoUrl } = useTheme();
  const { t } = useTranslation('bookingMembership');

  return (
    <Box
      marginBottom={20}
      css={{
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: '6px',
        overflow: 'hidden',
        color: '#2F2F2F',
      }}
    >
      <Flex
        padding="24px 24px 20px"
        backgroundColor="#143C21"
        flexDirection="column"
        gap="20px"
        css={{
          border: '1px solid #143C21',
          borderBottom: 'none',
        }}
      >
        <Flex gap="10px" alignItems="center" justifyContent="center">
          <Image
            src={
              coBrandedDisloyaltyLogoUrl ??
              '/disloyalty/disloyalty-full-text-logo.svg'
            }
            width={290}
            height={23}
            alt={`${themeKey} x disloyalty`}
          />
        </Flex>
        <Flex alignItems="center" justifyContent="center">
          <Text style="heading6" color="white">
            {t('sidePanel.title')}
          </Text>
        </Flex>
      </Flex>
      <Flex
        padding="20px 24px"
        backgroundColor="#FFF"
        gap="12px"
        justifyContent="center"
        css={{
          border: '1px solid #EEE0D1',
        }}
      >
        <BodySmall>
          {/* //benefits modal will be provided by disloyalty team in the future */}
          <a href="https://dis-loyalty.com/" target="_blank" rel="noreferrer">
            {t('benefits')}
          </a>
        </BodySmall>
        <Divider vertical inheritColor />
        <a href="https://dis-loyalty.com/" target="_blank" rel="noreferrer">
          <Flex gap="6px" alignItems="center">
            <BodySmall css={{ textDecoration: 'underline' }}>
              {t('sidePanel.signIn')}
            </BodySmall>
            <Image src={'/icons/export.svg'} width={11} height={11} alt="" />
          </Flex>
        </a>
      </Flex>
    </Box>
  );
};
